import * as yup from "yup";
import createValidationSchema from "../../../core/components/validation/createValidationSchema";
import {Localizer} from "../../../infrastructure/localization/localizer";
import {KlarmeldingModel, KlarmeldingTilBrugerModel} from "../klarmeldingModel";
import {KlarmeldingTypeEnum} from "../../../infrastructure/enums/klarmeldingTypeEnum";

export type KlarmeldingInputModel = {
    contextId?: string;
    klarmeldtTilAlleMedAdgang: boolean;
    klarmeldingType?: KlarmeldingTypeEnum;
    klarmeldBrugere?: KlarmeldingTilBrugerModel[];
}

export const AlleMedAdgangKey = "AllUsersWithAccess";

export const BuildExisting = (model: KlarmeldingModel, klarmeldingType: KlarmeldingTypeEnum): KlarmeldingInputModel => {
    return {
        contextId: model.contextId,
        klarmeldBrugere: model.klarmeldBrugere,
        klarmeldtTilAlleMedAdgang: model.klarmeldtTilAlleMedAdgang,
        klarmeldingType: klarmeldingType,
    };
}
export const BuildNew = (klarmeldingType: KlarmeldingTypeEnum): KlarmeldingInputModel => {
    return {
        contextId: undefined,
        klarmeldBrugere: undefined,
        klarmeldtTilAlleMedAdgang: false,
        klarmeldingType: klarmeldingType,
    };
}

export const CheckIfAllIsChosen = (inputModel: KlarmeldingInputModel) => {
    if (inputModel.klarmeldBrugere?.some(x => x.UserId === AlleMedAdgangKey)) {
        inputModel.klarmeldtTilAlleMedAdgang = true;
        inputModel.klarmeldBrugere = [];
    } else {
        inputModel.klarmeldtTilAlleMedAdgang = false;
    }
}

export const crudKlarmeldingValidationSchema = createValidationSchema<KlarmeldingInputModel>({
    contextId: yup.string().notRequired(),
    klarmeldtTilAlleMedAdgang: yup.boolean().notRequired(),
    klarmeldBrugere: yup.array().min(1, Localizer.validate_klarmeldTilEnEllerFlere()).required(Localizer.validate_fieldMustBeDefined(Localizer.global_klarmeldTil()))
});

